import {
  throwError as observableThrowError,
  forkJoin as observableForkJoin,
  of as observableOf,
  Observable,
  Subject,
  throwError,
  of,
  combineLatest as observableCombineLatest,
  retry,
} from 'rxjs';

import {catchError, map, first, mergeMap, switchMap, take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {APPCONFIG} from '../config';
import {EnvironmentConfigService} from '../core/services/environment-config.service';
import {FilterResult} from '../resource/filterresult';
import {
  ExportConfig,
  ExportModule,
  LocalizationConfig,
  ModuleAttribute,
  ModuleConfig,
  ResolvedAttribute,
  UILocalization,
  UIModule,
} from './moduleconfig';
import {
  HttpHeaders,
  HttpClient,
  HttpResponse,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import {User} from '../cache/currentuser/user';
import {CtrlFileuploadComponent} from '../resource/detail/controls/ctrl-fileupload.components';
import {ResourceUpdateStatus} from '../resource/resource.service';
import {environment} from '../../environments/environment';
import {LayoutService} from '../layout/layout.service';
import {Endpoint} from '../layout/endpoint';

@Injectable()
export class ModuleService {
  private headers: HttpHeaders;
  private runningCreates = 0;

  constructor(
    private http: HttpClient,
    private layoutService: LayoutService,
    private envConfig: EnvironmentConfigService,
  ) {
    this.headers = new HttpHeaders({'Content-Type': 'application/json'});
  }

  private blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  public exportModule(uiModule: UIModule, state: Subject<string>): Observable<any> {
    this.exportCalculated(uiModule.Filter, state).subscribe((data: any) => {
      const dataStr = JSON.stringify(data);
      //console.log(dataStr);
      //data:application/octet-stream;base64,
      this.blobToBase64(new Blob([dataStr])).then(res => {
        var resX: string;
        if (typeof res === 'string') {
          resX = <string>res;
        } else {
          resX = String.fromCharCode.apply(null, new Uint16Array(<ArrayBuffer>res));
        }
        // this next function breaks with large jsons
        //const matches = CtrlFileuploadComponent.dataUrlRegex.exec(resX);
        //matches[1]
        //console.log(res);
        const changes = {};
        changes['UIModuleExportConfig'] = resX.substring(37);
        this.updateResourceWithData(uiModule.ID, changes).subscribe();
        //console.log(base64data);
      });
    });

    return of(null);
  }

  public b64DecodeUnicode(str) {
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );
  }

  public u_atob(ascii) {
    return Uint8Array.from(atob(ascii), c => c.charCodeAt(0));
  }

  public decodeBase64(base64) {
    const text = atob(base64);
    const length = text.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = text.charCodeAt(i);
    }
    const decoder = new TextDecoder(); // default is utf-8
    return decoder.decode(bytes);
  }

  public base64_decode(s) {
    return decodeURIComponent(escape(atob(s)));
  }

  public syncModule(uiModule: UIModule, state: Subject<string>): Observable<any> {
    let exportConfig: ExportConfig = JSON.parse(this.b64DecodeUnicode(uiModule.ExportConfig));
    let importConfig: ExportConfig = JSON.parse(this.b64DecodeUnicode(uiModule.ImportConfig));
    //console.log(exportConfig);
    //console.log(importConfig);

    const changeConfig = {
      DisplayName: 'Identity Director Schema',
      Description: 'Identity Director Default Schema',
      Version: '1',
      Config: [],
    };

    importConfig.Export.forEach((importModule: ExportModule) => {
      //if(importModule.Filter.substring(0,6) == "/Group"){
      //if(true){
      //if(importModule.Filter == "/AttributeTypeDescription" || importModule.Filter == "/BindingDescription" || importModule.Filter == "/ObjectTypeDescription"){
      let objectType = importModule.Filter.substring(1);
      let changeModule = {
        ObjectType: objectType,
        Action: 'CreateUpdate',
        EqualityBase: ['DisplayName'],
        Resources: [],
      };

      if (importModule.Filter.substring(0, 6) == '/Group') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['AADObjectID'],
          Resources: [],
        };
      }
      if (importModule.Filter.substring(0, 33) == '/ObjectVisualizationConfiguration') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['DisplayName'],
          Resources: [],
        };
      }
      if (importModule.Filter.substring(0, 25) == '/SearchScopeConfiguration') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['DisplayName'],
          Resources: [],
        };
      }
      if (importModule.Filter.substring(0, 23) == '/ActionBarConfiguration') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['DisplayName'],
          Resources: [],
        };
      }
      if (importModule.Filter.substring(0, 27) == '/NavigationBarConfiguration') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['DisplayName'],
          Resources: [],
        };
      }
      if (importModule.Filter.substring(0, 22) == '/HomePageConfiguration') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['DisplayName'],
          Resources: [],
        };
      }
      if (importModule.Filter.substring(0, 14) == '/EmailTemplate') {
        changeModule = {
          ObjectType: objectType,
          Action: 'CreateUpdate',
          EqualityBase: ['DisplayName'],
          Resources: [],
        };
      }
      // check if objects are existing in exportConfig - then update
      // equality Bases have to be defined

      importModule.Result.forEach((resource: any) => {
        let found: boolean = false;
        //if not existing in exportModule add to changeConfig as add
        exportConfig.Export.forEach((exportModule: ExportModule) => {
          if (exportModule.Filter == importModule.Filter) {
            exportModule.Result.forEach((exportResource: any) => {
              if (exportResource.DisplayName === resource.DisplayName) {
                //found = true;
              }
            });
          }
        });
        if (!found) {
          //schema first
          let changeResource = {};
          /*
                            BoundAttributeType: {
                                Value: "Timeline",
                                EqualityBase: "Name",
                                ObjectType: "AttributeTypeDescription",
                                Action: "Create"
                            },
                         */

          Object.keys(resource).forEach((property: any) => {
            // remove read only attributes
            if (
              property != 'ChainID' &&
              property != 'ObjectID' &&
              property != 'ComputedMember' &&
              property != 'CreatedTime' &&
              property != 'Creator' &&
              property != 'MVObjectID' &&
              property != 'DomainConfiguration' &&
              property != 'Temporal' &&
              property != 'msidmDeferredEvaluation'
            ) {
              let attributeChange = {
                Action: 'CreateUpdate',
                Value: resource[property],
              };
              if (property == 'BoundAttributeType') {
                attributeChange['EqualityBase'] = 'Name';
                attributeChange['ObjectType'] = 'AttributeTypeDescription';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.Name;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'BoundObjectType') {
                attributeChange['EqualityBase'] = 'Name';
                attributeChange['ObjectType'] = 'ObjectTypeDescription';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.Name;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'ActionWorkflowDefinition') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'WorkflowDefinition';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'AuthenticationWorkflowDefinition') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'WorkflowDefinition';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'AuthorizationWorkflowDefinition') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'WorkflowDefinition';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'PrincipalSet') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'Set';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'ResourceCurrentSet') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'Set';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'ResourceFinalSet') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'Set';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'ActionBarResources') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'ActionBarConfiguration';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.DisplayName) {
                          referenceattributevalue.push(exportResource.DisplayName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'LinkedObject') {
                attributeChange['EqualityBase'] = 'DisplayName';
                attributeChange['ObjectType'] = 'Resource';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.DisplayName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'AzureMember') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });

                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'AzureOwner') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'ExplicitMember') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'Owner') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'SourceMember') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'SourceOwner') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'TeamOwners') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'DisplayedOwner') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = null;
                importConfig.Export.forEach((exportModule: ExportModule) => {
                  exportModule.Result.forEach((exportResource: any) => {
                    if (exportResource.ObjectID == resource[property]) {
                      referenceattributevalue = exportResource.AccountName;
                    }
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'ADMember') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }
              if (property == 'MemberImport') {
                attributeChange['EqualityBase'] = 'AccountName';
                attributeChange['ObjectType'] = 'Person';
                let referenceattributevalue = [];
                let refResources = resource[property];
                refResources.forEach((refResource: any) => {
                  importConfig.Export.forEach((exportModule: ExportModule) => {
                    exportModule.Result.forEach((exportResource: any) => {
                      if (exportResource.ObjectID == refResource) {
                        if (exportResource.AccountName) {
                          referenceattributevalue.push(exportResource.AccountName);
                        }
                      }
                    });
                  });
                });
                attributeChange['Value'] = referenceattributevalue;
              }

              changeResource[property] = attributeChange;
            }
          });
          changeModule.Resources.push(changeResource);
        }
      });
      changeConfig.Config.push(changeModule);
      //}
    });

    // save to changeConfig
    const dataStr = JSON.stringify(changeConfig);
    //console.log(dataStr);
    //data:application/octet-stream;base64,
    this.blobToBase64(new Blob([dataStr])).then(res => {
      var resX: string;
      if (typeof res === 'string') {
        resX = <string>res;
      } else {
        resX = String.fromCharCode.apply(null, new Uint16Array(<ArrayBuffer>res));
      }
      //console.log(resX);
      // this next function breaks with large jsons
      //const matches = CtrlFileuploadComponent.dataUrlRegex.exec(resX);
      //matches[1]
      //console.log(res);
      const changes = {};
      changes['UIModuleChangeConfig'] = resX.substring(37);
      this.updateResourceWithData(uiModule.ID, changes).subscribe();
      //console.log(base64data);
    });

    return of(null);
  }

  private compareExportModule(
    objectType: string,
    importModule: ExportModule,
    exportModule: ExportModule,
  ) {}

  private compareExportResource(objectType: string, importResource: any, exportResource: any) {}

  public installModule(uiModule: UIModule, state: Subject<string>): Observable<any> {
    return this.installConfigs(uiModule.Config, state);
  }

  public installLocalization(uiModule: UILocalization, state: Subject<string>): Observable<any> {
    return this.installLocalizationConfigs(uiModule.Localization, state);
  }
  private installLocalizationConfigs(
    moduleConfigs: LocalizationConfig[],
    state: Subject<string>,
  ): Observable<any> {
    const config: LocalizationConfig = moduleConfigs.shift();
    if (config == null) return observableOf(null);
    return this.processLocalizationModule(config, state).pipe(
      mergeMap((response: any) => {
        if (moduleConfigs === null) {
          return response;
        } else {
          return this.installLocalizationConfigs(moduleConfigs, state);
        }
      }),
    );
  }
  private processLocalizationModule(
    config: LocalizationConfig,
    state: Subject<string>,
  ): Observable<any> {
    console.log('Processing ' + config.LanguageCode);
    state.next('Processing ' + config.LanguageCode);

    let params = new HttpParams()
      .append('filter', '/' + this.envConfig.getObjectTypeName('SupportedLocaleConfiguration'))
      .append('attributes', [this.envConfig.getAttributeName('SupportedLanguageCode')].join(','))
      .append('pageSize', '1');
    return this.layoutService.endpoint$
      .pipe(
        take(1),
        switchMap((env: Endpoint) => {
          return this.http.get(env.getUrl() + 'v2/resources/', {
            headers: this.headers,
            params: params,
            ...(!env.isCloud() ? {withCredentials: true} : {}),
          });
        }),
      )
      .pipe(
        mergeMap((response: FilterResult) => {
          if (
            response != null &&
            response.Results != null &&
            Array.isArray(response.Results) &&
            response.TotalCount != null &&
            response.TotalCount > 0
          ) {
            const languageCodes: string[] = ['neutrallocale'];
            response.Results[0].SupportedLanguageCode.forEach(item => {
              languageCodes.push(item.substring(0, 2).toLowerCase());
            });

            if (languageCodes.indexOf(config.LanguageCode.toLowerCase()) !== -1) {
              // Create Or Update Resource
              const filter = '/' + this.envConfig.getObjectTypeName('UIConfiguration');
              return this.searchResources(filter, this.envConfig.getAttributeName('ObjectID')).pipe(
                first(),
                mergeMap((res: FilterResult) => {
                  if (
                    res != null &&
                    res.Results != null &&
                    Array.isArray(res.Results) &&
                    res.TotalCount != null &&
                    res.TotalCount > 0
                  ) {
                    // Resource found -> update resource

                    let params: HttpParams = new HttpParams();

                    if (
                      config.LanguageCode != null &&
                      config.LanguageCode !== '*' &&
                      config.LanguageCode !== 'NeutralLocale'
                    ) {
                      params = params.append('locale', config.LanguageCode);
                    }

                    let returnResource = {};
                    returnResource[this.envConfig.getAttributeName('StringResources')] =
                      config.StringResources;

                    let jsonChanges: string = JSON.stringify(returnResource);
                    if (jsonChanges === '{}') {
                      return observableOf<ResourceUpdateStatus>(ResourceUpdateStatus.Success);
                    }
                    return this.layoutService.endpoint$
                      .pipe(
                        take(1),
                        switchMap((env: Endpoint) => {
                          let url: string =
                            env.getUrl() + 'v2/resources/' + res.Results[0].ObjectID + '/';
                          return this.http.patch(url, jsonChanges, {
                            headers: this.headers,
                            observe: 'response',
                            params: params,
                            ...(!env.isCloud() ? {withCredentials: true} : {}),
                          });
                        }),
                      )
                      .pipe(
                        map((response: HttpResponse<any>) => {
                          if (response.status === 202) {
                            // see https://github.com/lithnet/resourcemanagement-webservice/wiki/Error-handling#v2-api
                            return ResourceUpdateStatus.ApprovalPending;
                          } else if (response.ok) {
                            return ResourceUpdateStatus.Success;
                          } else {
                            return ResourceUpdateStatus.Fail;
                          }
                        }),
                      );
                  }
                }),
                catchError((error: any) => ModuleService.handleError(error)),
              );
            } else {
              return of(null);
            }
          }
        }),
      );
  }

  private exportCalculated(filters: string[], state: Subject<string>): Observable<any> {
    const obs: Array<Observable<any>> = [];

    filters.forEach((filter: string) => {
      obs.push(
        this.exportSingleCalculated(filter, state).pipe(
          map((result: any) => {
            let exportModule: ExportModule = <ExportModule>{
              Filter: filter,
            };
            exportModule.Result = result;
            return exportModule;
          }),
        ),
      );
    });
    return observableCombineLatest(obs).pipe(
      map((results: any[]) => {
        let exportConfig: ExportConfig = <ExportConfig>{
          Type: 'Calculated',
          Export: [],
        };
        results.forEach(result => {
          exportConfig.Export.push(result);
        });
        return exportConfig;
      }),
    );
  }

  private exportSingleCalculated(filter: string, state: Subject<string>): Observable<any> {
    return this.searchFilterResources(filter).pipe(
      first(),
      map((res: FilterResult) => {
        if (
          res != null &&
          res.Results != null &&
          Array.isArray(res.Results) &&
          res.TotalCount != null &&
          res.TotalCount > 0
        ) {
          console.log('Resource found -> update resource');
          return res.Results;
        } else {
          return null;
        }
      }),
      catchError((error: any) => ModuleService.handleError(error)),
    );
  }

  private installConfigs(moduleConfigs: ModuleConfig[], state: Subject<string>): Observable<any> {
    const config: ModuleConfig = moduleConfigs.shift();
    if (config == null) return observableOf(null);
    return this.processModule(config, state).pipe(
      mergeMap((response: any) => {
        if (moduleConfigs === null) {
          return response;
        } else {
          return this.installConfigs(moduleConfigs, state);
        }
      }),
    );
  }

  public getTimelineModuleExtension(): Observable<any> {
    return this.searchResources(
      '/ObjectTypeDescription',
      this.envConfig.getAttributeName('Name'),
    ).pipe(
      first(),
      map((res: FilterResult) => {
        if (
          res != null &&
          res.Results != null &&
          Array.isArray(res.Results) &&
          res.TotalCount != null &&
          res.TotalCount > 0
        ) {
          // Resource found -> update resource
          let timelinemodule = {
            ObjectType: 'BindingDescription',
            Action: 'Create',
            EqualityBase: ['BoundAttributeType', 'BoundObjectType'],
            Resources: [],
          };
          res.Results.forEach((resource: any) => {
            timelinemodule.Resources.push({
              BoundAttributeType: {
                Value: 'Timeline',
                EqualityBase: 'Name',
                ObjectType: 'AttributeTypeDescription',
                Action: 'Create',
              },
              BoundObjectType: {
                Value: resource[this.envConfig.getAttributeName('Name')],
                EqualityBase: 'Name',
                ObjectType: 'ObjectTypeDescription',
                Action: 'Create',
              },
              DisplayName: {
                Value: 'Timeline',
                Action: 'Create',
              },
              Description: {
                Value: 'Timeline',
                Action: 'Create',
              },
              ObjectType: {
                Value: 'BindingDescription',
                Action: 'Create',
              },
              Required: {
                Value: false,
                Action: 'Create',
              },
            });
            timelinemodule.Resources.push({
              BoundAttributeType: {
                Value: 'UIModules',
                EqualityBase: 'Name',
                ObjectType: 'AttributeTypeDescription',
                Action: 'Create',
              },
              BoundObjectType: {
                Value: resource[this.envConfig.getAttributeName('Name')],
                EqualityBase: 'Name',
                ObjectType: 'ObjectTypeDescription',
                Action: 'Create',
              },
              DisplayName: {
                Value: 'UI Modules',
                Action: 'Create',
              },
              Description: {
                Value: 'UI Modules',
                Action: 'Create',
              },
              ObjectType: {
                Value: 'BindingDescription',
                Action: 'Create',
              },
              Required: {
                Value: false,
                Action: 'Create',
              },
            });
          });
          return timelinemodule;
        } else {
          return null;
        }
      }),
      catchError((error: any) => ModuleService.handleError(error)),
    );
  }

  private processModule(config: ModuleConfig, state: Subject<string>): Observable<any> {
    console.log(
      'Processing ' +
        config.Action +
        ': ' +
        config.ObjectType +
        ' on equality base ' +
        config.EqualityBase,
    );
    state.next('Processing ' + config.Action + ': ' + config.ObjectType);
    switch (config.Action) {
      case 'Create':
        return this.createOrUpdateResourceArray(
          config.ObjectType,
          config.EqualityBase,
          config.Resources,
          config.Action,
        );
      case 'CreateUpdate':
        return this.createOrUpdateResourceArray(
          config.ObjectType,
          config.EqualityBase,
          config.Resources,
          config.Action,
        );
      case 'Update':
        return this.createOrUpdateResourceArray(
          config.ObjectType,
          config.EqualityBase,
          config.Resources,
          config.Action,
        );
      case 'Delete':
        return this.createOrUpdateResourceArray(
          config.ObjectType,
          config.EqualityBase,
          config.Resources,
          config.Action,
        );
    }
    console.log(
      'Processing Ended' +
        config.Action +
        ': ' +
        config.ObjectType +
        ' on equality base ' +
        config.EqualityBase,
    );
  }

  private createOrUpdateResourceArray(
    objectType: string,
    equalityBase: string[],
    resources: any[],
    actions: string,
  ): Observable<any> {
    if (actions === 'Create' || actions === 'CreateUpdate') {
      const resource: ModuleConfig = resources.shift();
      if (resource == null) return observableOf(null);
      return this.resolveReferences(resource).pipe(
        mergeMap(patchedResource =>
          this.createOrUpdateResource(objectType, equalityBase, patchedResource, actions),
        ),
        catchError((error: any) => ModuleService.handleError(error)),
        mergeMap((response: any) => {
          if (resources === null) {
            return response;
          } else {
            return this.createOrUpdateResourceArray(objectType, equalityBase, resources, actions);
          }
        }),
      );
    } else {
      let obsList: Observable<any>[] = [];
      resources.forEach((resource: any) => {
        obsList.push(
          this.resolveReferences(resource).pipe(
            mergeMap(patchedResource =>
              this.createOrUpdateResource(objectType, equalityBase, patchedResource, actions),
            ),
            catchError((error: any) => ModuleService.handleError(error)),
          ),
        );
      });
      return observableForkJoin(obsList);
    }
  }

  private resolveAttribute(
    key: string,
    attributeConfig: ModuleAttribute,
    value: string,
  ): Observable<ResolvedAttribute> {
    return this.searchResources(
      ModuleService.buildSingleMappingFilter(
        attributeConfig.ObjectType,
        attributeConfig.EqualityBase,
        value,
      ),
      this.envConfig.getAttributeName('ObjectID'),
    ).pipe(
      first(),
      map((res: FilterResult) => {
        if (
          res != null &&
          res.Results != null &&
          Array.isArray(res.Results) &&
          res.TotalCount != null &&
          res.TotalCount > 0
        ) {
          // Resource found -> update resource
          return {
            Key: key,
            Value: res.Results[0][this.envConfig.getAttributeName('ObjectID')],
          };
        } else {
          return {
            Key: key,
            Value: null,
          };
        }
      }),
      catchError((error: any) => ModuleService.handleError(error)),
    );
  }

  private resolveReferences(resource: any): Observable<any> {
    let obsList: Observable<any>[] = [];
    Object.keys(resource).forEach((key: string) => {
      if (resource[key].EqualityBase) {
        if (Array.isArray(resource[key].Value)) {
          let obs: Observable<any>[] = [];
          if (resource[key].Value.length > 0) {
            resource[key].Value.forEach((value: any) => {
              obs.push(this.resolveAttribute(key, resource[key], value).pipe(retry(1000)));
            });
            obsList.push(
              observableForkJoin(obs).pipe(
                catchError((error: any) => ModuleService.handleError(error)),
                map((resolvedValues: ResolvedAttribute[]) => {
                  let resolvedAttribute = {
                    Key: key,
                    Value: [],
                  };
                  resolvedValues.forEach((value: ResolvedAttribute) => {
                    if (value.Value != null) {
                      resolvedAttribute.Value.push(value.Value);
                    }
                  });
                  return resolvedAttribute;
                }),
              ),
            );
          } else {
            obsList.push(
              observableOf({
                Key: key,
                Value: null,
              }),
            );
          }
        } else {
          obsList.push(this.resolveAttribute(key, resource[key], resource[key].Value));
        }
      } else {
        obsList.push(
          observableOf({
            Key: key,
            Value: resource[key].Value,
          }),
        );
      }
    });
    return observableForkJoin(obsList).pipe(
      map((attributeConfigs: ResolvedAttribute[]) => {
        attributeConfigs.forEach((resolvedAttribute: ResolvedAttribute) => {
          if (resolvedAttribute.Value !== null) {
            resource[resolvedAttribute.Key].Value = resolvedAttribute.Value;
          } else {
            delete resource[resolvedAttribute.Key];
          }
        });
        return resource;
      }),
    );
  }

  private static handleError(error: HttpErrorResponse) {
    console.error(error);
    //return Observable.throw(error || 'Server error');
    return throwError(() => new Error('Injection Error ' + error || 'Server error'));
  }

  private buildMappingFilter(objecttype: string, equalityBase: string[], resource: any) {
    let filter = '/' + objecttype + '[';
    equalityBase.forEach((mappingAttribute: string) => {
      if (filter.endsWith(')')) filter += ' and ';
      filter += '(';
      filter += mappingAttribute + ' = "' + resource[mappingAttribute].Value + '"';
      filter += ')';
    });
    return (filter += ']');
  }

  private static buildSingleMappingFilter(
    objecttype: string,
    attribute: string,
    value: any,
  ): string {
    return '/' + objecttype + '[' + attribute + '="' + value + '"]';
  }

  private patchResource(resource: any, original: any, isCreate: boolean): Observable<any> {
    if (isCreate) {
      let returnResource = {};
      Object.keys(resource).forEach((key: string) => {
        returnResource[key] = resource[key].Value;
      });
      return observableOf(returnResource);
    } else {
      let returnResource = {ObjectID: original.ObjectID};
      Object.keys(resource).forEach((key: string) => {
        switch (resource[key].Action) {
          case 'CreateUpdate':
            returnResource[key] = resource[key].Value;
            break;
          case 'Create':
            break;
          case 'Modify':
            returnResource[key] = resource[key].Value;
            break;
          case 'Insert':
            returnResource[key] = this.addValues(original[key], resource[key].Value);
            break;
          case 'Remove':
            returnResource[key] = this.removeValues(original[key], resource[key].Value);
            break;
          case 'Delete':
            returnResource[key] = '';
            break;
          case 'Ignore':
            break;
        }
      });
      return observableOf(returnResource);
    }
  }

  private removeValues(original: any[], remove: any[]): any[] {
    let newArray: any[] = original;
    remove.forEach((value: any) => {
      if (newArray.indexOf(value) !== -1) newArray.slice(newArray.indexOf(value));
    });
    return newArray;
  }

  private addValues(original: any[], add: any[]): any[] {
    return [...new Set((original ?? []).concat(add ?? []))];
    let newArray: any[] = [];
    if (original) {
      original.forEach((value: any) => {
        if (newArray.indexOf(value) === -1) newArray.push(value);
      });
    }
    add.forEach((value: any) => {
      if (newArray.indexOf(value) === -1) newArray.push(value);
    });
    return newArray;
  }

  private createOrUpdateResource(
    objectType: string,
    equalityBase: string[],
    resource: any,
    action: string,
  ): Observable<any> {
    // Create Or Update Resource
    const filter = this.buildMappingFilter(objectType, equalityBase, resource);
    return this.searchResources(filter, Object.keys(resource).join(',')).pipe(
      first(),
      mergeMap((res: FilterResult) => {
        if (
          res != null &&
          res.Results != null &&
          Array.isArray(res.Results) &&
          res.TotalCount != null &&
          res.TotalCount > 0
        ) {
          // Resource found -> update resource
          if (action === 'Update' || action === 'CreateUpdate') {
            return this.patchResource(resource, res.Results[0], false).pipe(
              mergeMap(patchedResource =>
                this.updateResourceWithData(
                  patchedResource[this.envConfig.getAttributeName('ObjectID')],
                  patchedResource,
                ),
              ),
            );
          } else if (action === 'Delete') {
            console.log(
              'Resource found and deleted: ' +
                resource[this.envConfig.getAttributeName('DisplayName')] +
                ' ' +
                res.Results[0][this.envConfig.getAttributeName('ObjectID')],
            );
            return this.deleteResource(res.Results[0][this.envConfig.getAttributeName('ObjectID')]);
          } else {
            console.log(
              'Resource found and not updated: ' +
                resource[this.envConfig.getAttributeName('DisplayName')],
            );
            return observableOf(null);
          }
        } else {
          // Resource not found -> create resource
          if (action === 'Create' || action === 'CreateUpdate') {
            return this.patchResource(resource, null, true).pipe(
              mergeMap(patchedResource => this.createResourceWithData(patchedResource)),
            );
          } else {
            console.log(
              'Resource not found and not created: ' +
                resource[this.envConfig.getAttributeName('DisplayName')],
            );
            return observableOf(null);
          }
        }
      }),
      catchError((error: any) => ModuleService.handleError(error)),
    );
  }

  private createResourceWithData(data: any): Observable<HttpResponse<any>> {
    const objectIdAttr = this.envConfig.getAttributeName('ObjectID');
    if (data[objectIdAttr] != null) {
      delete data[objectIdAttr];
    }

    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) => {
        return this.http.post(env.getUrl() + 'v2/resources/', JSON.stringify(data), {
          headers: headers,
          observe: 'response',
          ...(!env.isCloud() ? {withCredentials: true} : {}),
        });
      }),
    );
  }

  public searchResources(filter: string, attributes: string): Observable<FilterResult> {
    if (filter == null || filter.length === 0) {
      return observableThrowError("Invalid Filter-XPath: '" + filter + "'");
    }

    const attributesRegex = new RegExp(
      '^([a-zA-Z_:][a-zA-Z0-9-._:]*)(,([a-zA-Z_:][a-zA-Z0-9-._:]*)+)*$',
    );
    if (!attributesRegex.test(attributes)) {
      return observableThrowError('Invalid attributes: ' + attributes);
    }
    let params = new HttpParams().append('filter', filter).append('attributes', attributes);

    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) => {
        return this.http.get<FilterResult>(env.getUrl() + 'v2/resources/', {
          headers: headers,
          params: params,
          ...(!env.isCloud() ? {withCredentials: true} : {}),
        });
      }),
    );
  }

  public searchFilterResources(filter: string): Observable<FilterResult> {
    if (filter == null || filter.length === 0) {
      return observableThrowError("Invalid Filter-XPath: '" + filter + "'");
    }
    let params = new HttpParams();
    if (filter == '/Set') {
      params = new HttpParams()
        .append('filter', filter)
        .append('pageSize', '' + 10000)
        .append('attributes', 'DisplayName,Description,Filter,ObjectID,ObjectType');
    } else if (filter == '/Person') {
      params = new HttpParams()
        .append('filter', filter)
        .append('pageSize', '' + 20000)
        .append('attributes', 'DisplayName,AccountName,ObjectID,ObjectType');
    } else {
      params = new HttpParams().append('filter', filter).append('pageSize', '' + 10000);
    }

    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) => {
        return this.http.get<FilterResult>(env.getUrl() + 'v2/resources/', {
          headers: headers,
          params: params,
          ...(!env.isCloud() ? {withCredentials: true} : {}),
        });
      }),
    );
  }

  public updateResourceWithData(id: string, changes: any): Observable<any> {
    const objectIdAttr = this.envConfig.getAttributeName('ObjectID');
    if (changes[objectIdAttr] != null) {
      delete changes[objectIdAttr];
    }

    let jsonChanges: string = JSON.stringify(changes);
    if (jsonChanges === '{}') {
      return observableOf(null);
    }
    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) => {
        let url: string = env.getUrl() + 'v2/resources/' + id + '/';
        return this.http.patch(url, jsonChanges, {
          headers: this.headers,
          ...(!env.isCloud() ? {withCredentials: true} : {}),
        });
      }),
      catchError(ModuleService.handleError),
    );
  }

  public deleteResource(id: string): Observable<boolean> {
    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) => {
        let url: string = env.getUrl() + 'v2/resources/' + id + '/';
        return this.http.delete(url, {
          headers: this.headers,
          observe: 'response',
          ...(!env.isCloud() ? {withCredentials: true} : {}),
        });
      }),
      map((response: HttpResponse<any>) => {
        return response.ok;
      }),
      catchError(ModuleService.handleError),
    );
  }
}
